module.exports = __webpack_public_path__ + "static/media/no_vibration.0bc64cda.png";